import styled from '@emotion/styled';

export const Label = styled.p`
  margin-bottom: ${props => props.theme.spacing.xxs};
`;

export const FinancialValueText = styled.div`
  text-align: right;
  margin-right: ${props => props.theme.spacing.md};
`;

export const SummaryValueText = styled.p`
  font-size: ${props => (props.isText ? '24px' : '32px')};
  font-weight: ${props => props.theme.fontWeight.bold};
  margin-bottom: 0;
`;

export const ResourceTypeLabel = styled.div`
  margin: -${props => props.theme.spacing.xs} auto;
  font-weight: ${props => props.theme.fontWeight.bold};
`;
